<template>
    <v-dialog v-model="dialog" width="700" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div class="w-75 text-truncate text-white">
                    <span class="font-weight-bold text-h6">{{ dialog_title }}</span>
                    <div class="text-caption">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <div class="font-weight-bold text-red">Notes:</div>
                            <div class="text-red">*Please select all files you wish to upload at once.</div>
                            <div class="text-red">*Also please submit files with short names.</div>
                            <!-- “This compliance require {{ this.compliance.max_upload }} pdf uploads.” -->
                        </v-col>
                        <v-col cols="12">
                            <v-file-upload
                                v-model="files"
                                type="file"
                                rounded="lg"
                                height="310"
                                clearable
                                show-size
                                multiple
                                elevation="1"
                                scrim="darkGreen"
                                accept="application/pdf"
                                >
                            </v-file-upload>
                        </v-col>
                        <v-col v-if="compliance.id == 2" cols="12">
                            <v-select
                                v-model="exam_day"
                                :rules="[formRules.required]"
                                label="Exam Day"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :loading="loading"
                                :items="examDayData"
                                item-title="name"
                                item-value="id"
                                >
                            </v-select>
                        </v-col>
                        <v-col v-if="compliance.id == 2" cols="12">
                            <v-text-field
                                v-model="number_of_copies"
                                :rules="[formRules.required]"
                                label="Number of Copies"
                                variant="outlined"
                                rounded="lg"
                                type="number"
                                color="darkGreen"
                                >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmit" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to resubmit your compliance?</div>
                <div class="font-weight-light mt-2">Note: Once resubmitted, some details may not be updated. Please review your compliance information carefully before proceeding.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmSubmit = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="resubmitCompliance()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["refresh"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            file_id: null,
            filesToDelete: null,
            files: [],
            compliance: null,
            compliance_data: null,
            exam_day: null,
            number_of_copies: null,

            examDayData: ['Day 1', 'Day 2', 'Day 3', 'Day 4', 'Day 5', 'Day 6', 'Day 7',],
            confirmSubmit: false,

            newFormRules: {

            },
        }
     },
     methods: {
        init(data){
            this.dialog = true
            this.dialog_title = 'Resubmit Files'
            this.dialog_sub_title = data.compliance.compliance_name + " - " + data.facultyLoad.code + " - " + data.facultyLoad.title
            this.action = 'edit'

            this.file_id = data.file.id
            this.filesToDelete = data.file.filenames || []
            this.files = []
            this.compliance = data.compliance
            this.compliance_data = data
            this.exam_day = data.file.exam_day
            this.number_of_copies = data.file.number_of_copies
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            if (!this.files || this.files.length === 0) {
                showSnackbar('Please upload files.', 'error')
                return
            }
            this.confirmSubmit = true
        },
        async resubmitCompliance(){
            const { showSnackbar } = useSnackbar()
            this.loading = true

            let formData = new FormData()

            const complianceData = {
                compliance: {
                    compliance_name: this.compliance_data?.compliance?.compliance_name,
                },
                facultyLoad: {
                    code: this.compliance_data?.facultyLoad?.code,
                },
                semester_schoolyear_id: this.compliance_data?.semester_schoolyear_id,
                user_id: this.compliance_data?.user_id,
                file: {
                    reviewer_id: this.compliance_data?.file?.reviewer_id,
                    filenames: this.compliance_data?.file?.filenames,
                },
            }

            let form = {
                file_id: this.file_id,
                created_by: this.$store.state.user.id,
                filesToDelete: this.filesToDelete,
                exam_day: this.exam_day,
                number_of_copies: this.number_of_copies,
                compliance_data: complianceData,
            }

            if (Array.isArray(this.files) && this.files.length > 0) {
                for (let i = 0; i < this.files.length; i++) {
                    const file = this.files[i]
                    if (file instanceof File || file instanceof Blob) {
                        formData.append('files', file);
                    }
                }
            }

            formData.append('data', JSON.stringify(form))
            const token = localStorage.getItem('aums-token')

            try {
                const res = await axios.post(process.env.VUE_APP_SERVER_URL + '/compliance-upload/resubmitCompliance', formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })

                if (res.data && res.data.status == 200) {
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Resubmit Files successfully!')
                    this.$refs.form.reset()
                    this.confirmSubmit = false
                    this.dialog = false
                } else {
                    this.loading = false
                    const message = (res.data && res.data.msg) ? res.data.msg : 'Unable to resubmit compliance.'
                    showSnackbar(message, 'error')
                }
            } catch (error) {
                this.loading = false
                if (error.response && error.response.status == 401) {
                    showSnackbar('Token expired! Logging out..')
                    localStorage.removeItem("vuex")
                    localStorage.removeItem("aums-token")
                    window.location.reload()
                } else {
                    console.error(error)
                    showSnackbar('Unable to resubmit compliance.', 'error')
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>